import AudioClicksIcon from '@/shared/assets/icons/advanced-settings/audio-clicks.svg?react';
import BuzzerIcon from '@/shared/assets/icons/advanced-settings/buzzer.svg?react';
import FeedbackIcon from '@/shared/assets/icons/advanced-settings/feedback.svg?react';
import RandomReverseIcon from '@/shared/assets/icons/advanced-settings/random-reverse.svg?react';
import ResponseTaskIcon from '@/shared/assets/icons/advanced-settings/response-task.svg?react';
import LinearPathkIcon from '@/shared/assets/icons/advanced-settings/trajectories/linear-path.svg?react';
import BouncingPathkIcon from '@/shared/assets/icons/advanced-settings/trajectories/bouncing-path.svg?react';
import EllipsePathkIcon from '@/shared/assets/icons/advanced-settings/trajectories/ellipse-path.svg?react';
import InfinityPathkIcon from '@/shared/assets/icons/advanced-settings/trajectories/infinity-path.svg?react';
import ColorSilverIcon from '@/shared/assets/icons/advanced-settings/colors/color-silver.svg?react';
import ColorRedIcon from '@/shared/assets/icons/advanced-settings/colors/color-red.svg?react';
import ColorBlueIcon from '@/shared/assets/icons/advanced-settings/colors/color-blue.svg?react';
import ColorPurpleIcon from '@/shared/assets/icons/advanced-settings/colors/color-purple.svg?react';
import EMDRPlusIcon from '@/shared/assets/icons/treatment-creation-result/info-panel/EMDR-Plus.svg?react';
import EMDRRemoteIcon from '@/shared/assets/icons/treatment-creation-result/info-panel/EMDR-Remote.svg?react';
import EMDRVRIcon from '@/shared/assets/icons/treatment-creation-result/info-panel/EMDR-VR.svg?react';
import MHIcon from '@/shared/assets/icons/treatment-creation-result/info-panel/MH.svg?react';

/**
 * Maping iconName string to SVG Icon component
 * @param iconName icon name
 * @returns SVG Icon component
 */
export const mapIconsNameToIcon = (iconName) => {
  switch (iconName) {
    case 'response-task':
      return <ResponseTaskIcon />;
    case 'audio-clicks':
      return <AudioClicksIcon />;
    case 'random-reverse':
      return <RandomReverseIcon />;
    case 'feedback':
      return <FeedbackIcon />;
    case 'buzzer':
      return <BuzzerIcon />;
    case 'linear-path':
      return <LinearPathkIcon />;
    case 'bouncing-path':
      return <BouncingPathkIcon />;
    case 'ellipse-path':
      return <EllipsePathkIcon />;
    case 'infinity-path':
      return <InfinityPathkIcon />;
    case 'EMDR-Plus':
      return <EMDRPlusIcon />;
    case 'EMDR-Remote':
      return <EMDRRemoteIcon />;
    case 'EMDR-VR':
      return <EMDRVRIcon />;
    case 'silver-ball':
      return <ColorSilverIcon />;
    case 'red-ball':
      return <ColorRedIcon />;
    case 'blue-ball':
      return <ColorBlueIcon />;
    case 'purple-ball':
      return <ColorPurpleIcon />;
  }
};

/**
 * Generate ID consts based on products
 * @param products Wizard products
 * @returns ID consts based on products
 */
export const getProductIdsConsts = (products) => {
  let EMDR_PlusId;
  let EMDR_RemoteId;
  let EMDR_VrId;
  let MHId;
  products?.forEach((product) => {
    switch (product.name) {
      case 'EMDR-Plus':
        EMDR_PlusId = product.id;
        break;
      case 'EMDR-Remote':
        EMDR_RemoteId = product.id;
        break;
      case 'EMDR-VR':
        EMDR_VrId = product.id;
        break;
      case 'Medical Hypnosis':
        MHId = product.id;
        break;
    }
  });
  return { EMDR_PlusId, EMDR_RemoteId, EMDR_VrId, MHId };
};

export const ADVANCED_SETTINGS_GROUPS = {
  GENERAL: 'General Settings',
  TASK: 'Task Settings',
  SPHERE: 'Sphere Settings',
  REACTION: 'Reaction Settings',
  AUDIO: 'Audio Settings',
};
